/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdMedalsGraphic } from './GetCharactersCharacterIdMedalsGraphic';
import {
    GetCharactersCharacterIdMedalsGraphicFromJSON,
    GetCharactersCharacterIdMedalsGraphicFromJSONTyped,
    GetCharactersCharacterIdMedalsGraphicToJSON,
    GetCharactersCharacterIdMedalsGraphicToJSONTyped,
} from './GetCharactersCharacterIdMedalsGraphic';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdMedals200Ok
 */
export interface GetCharactersCharacterIdMedals200Ok {
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    corporationId: number;
    /**
     * date string
     * @type {Date}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    date: Date;
    /**
     * description string
     * @type {string}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    description: string;
    /**
     * graphics array
     * @type {Array<GetCharactersCharacterIdMedalsGraphic>}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    graphics: Array<GetCharactersCharacterIdMedalsGraphic>;
    /**
     * issuer_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    issuerId: number;
    /**
     * medal_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    medalId: number;
    /**
     * reason string
     * @type {string}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    reason: string;
    /**
     * status string
     * @type {string}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    status: GetCharactersCharacterIdMedals200OkStatusEnum;
    /**
     * title string
     * @type {string}
     * @memberof GetCharactersCharacterIdMedals200Ok
     */
    title: string;
}


/**
 * @export
 */
export const GetCharactersCharacterIdMedals200OkStatusEnum = {
    Public: 'public',
    Private: 'private'
} as const;
export type GetCharactersCharacterIdMedals200OkStatusEnum = typeof GetCharactersCharacterIdMedals200OkStatusEnum[keyof typeof GetCharactersCharacterIdMedals200OkStatusEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdMedals200Ok interface.
 */
export function instanceOfGetCharactersCharacterIdMedals200Ok(value: object): value is GetCharactersCharacterIdMedals200Ok {
    if (!('corporationId' in value) || value['corporationId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('graphics' in value) || value['graphics'] === undefined) return false;
    if (!('issuerId' in value) || value['issuerId'] === undefined) return false;
    if (!('medalId' in value) || value['medalId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdMedals200OkFromJSON(json: any): GetCharactersCharacterIdMedals200Ok {
    return GetCharactersCharacterIdMedals200OkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMedals200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMedals200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'corporationId': json['corporation_id'],
        'date': (new Date(json['date'])),
        'description': json['description'],
        'graphics': ((json['graphics'] as Array<any>).map(GetCharactersCharacterIdMedalsGraphicFromJSON)),
        'issuerId': json['issuer_id'],
        'medalId': json['medal_id'],
        'reason': json['reason'],
        'status': json['status'],
        'title': json['title'],
    };
}

export function GetCharactersCharacterIdMedals200OkToJSON(json: any): GetCharactersCharacterIdMedals200Ok {
    return GetCharactersCharacterIdMedals200OkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMedals200OkToJSONTyped(value?: GetCharactersCharacterIdMedals200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'corporation_id': value['corporationId'],
        'date': ((value['date']).toISOString()),
        'description': value['description'],
        'graphics': ((value['graphics'] as Array<any>).map(GetCharactersCharacterIdMedalsGraphicToJSON)),
        'issuer_id': value['issuerId'],
        'medal_id': value['medalId'],
        'reason': value['reason'],
        'status': value['status'],
        'title': value['title'],
    };
}

